<template>
    <div>
        <el-container>
            <el-header height="auto"><common-header ref="headerRef"/></el-header>
            <el-container class="page-content">
                <el-aside class="no-top" width="auto">
                    <common-asideVue />
                </el-aside>
                <el-main class="el-main">
                    <common-right />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import ElContainer from "element-ui/packages/container/src/main";
    import CommonAsideVue from '@/components/CommonAside.vue'
    import CommonHeader from '@/components/CommonHeader.vue'
    import CommonRight from '@//components/CommonRight.vue'
    import { userCallback } from '../api/index';
    import Cookie from 'js-cookie';
    export default {
        components: {ElContainer,CommonHeader,CommonAsideVue,CommonRight},
        name: "pageindex",
        data () {
            return {}
        },
        activated () {
            // const {code, state} = this.$route.query;
            // const _this = this;
            // if(code && state) {
            //     userCallback(code, state).then(res => {
            //         if(res.data.code == 1 && res.data.data.is_bind == '1') {
            //             // 绑定直接登录
            //            Cookie.set('phoneKey', res.data.data.userinfo.mobile);
            //            Cookie.set('userinfo',JSON.stringify(res.data.data.userinfo));
            //            _this.$refs.headerRef.loadUser();
            //         }
            //         else {
            //             _this.$router.push('/login');
            //         }
            //     })
            // }
            // else {
            //     _this.$router.push('/login');
            // }
        },
        methods: {

        }
    }
</script>

<style >
    .el-header{
        padding:0;
        background: #42B134;
    }

    .no-top /deep/ .el-menu{
        margin-top: 0;
    }
    .page-content{
        width: 1200px;
        margin: auto;
    }
    .el-main{
        padding: 20px;
        padding-right: 0;
    }
</style>